import React from 'react'
import { observer } from 'mobx-react'
import { Card, Col, Row, Typography, Tooltip, Empty } from 'antd'
import { FolderOutlined, FileTextOutlined } from '@ant-design/icons'
import { blue } from '../../color'
import AppPagination from '../../components/Common/AppPagination'

const { Text } = Typography

const MyDocumentGridView = ({ store, onMove, onShare, fetchData }) => {
  const data = [...store.myDocumentList, ...store.sharedDocumentList]

  if (data.length === 0) {
    return <Empty description="Không có dữ liệu" style={{ marginTop: 100 }} />
  }

  return (
    <div>
      <Row gutter={[16, 16]}>
        {data.map(item => {
          const isFolder = item.type === 'folder'
          return (
            <Col xs={12} sm={8} md={6} lg={4} key={item.id}>
              <Card
                hoverable
                style={{ textAlign: 'center', height: '100%', borderRadius: 8 }}
                bodyStyle={{ padding: 16 }}
                onClick={() => {
                  if (isFolder) {
                    store.setCurrentParentId(item.id)
                  }
                }}
              >
                {isFolder ? (
                  <FolderOutlined style={{ fontSize: 48, color: '#faad14' }} />
                ) : (
                  <FileTextOutlined style={{ fontSize: 48, color: blue }} />
                )}
                <div style={{ marginTop: 12 }}>
                  <Tooltip title={item.name}>
                    <Text ellipsis={{ tooltip: item.name }} style={{ width: '100%' }}>
                      {item.name}
                    </Text>
                  </Tooltip>
                </div>
              </Card>
            </Col>
          )
        })}
      </Row>

      <div style={{ marginTop: 24, textAlign: 'right' }}>
        <AppPagination
            page={store.queryParams.page + 1}
            size={store.queryParams.size}
            totalCount={store.totalCount + store.sharedTotalCount}
            onChange={(page, size) => {
                store.setQueryParams({ page: page - 1, size })
                fetchData()
            }}
        />
      </div>
    </div>
  )
}

export default observer(MyDocumentGridView)
